export const statusReasonsRejection = (t: any) => [
  {
    value: 'ICR',
    label: t('h173'),
  },
  {
    value: 'RPH',
    label: t('h174'),
  },
  {
    value: 'BQA',
    label: t('h175'),
  },
  {
    value: 'RQS',
    label: t('h176'),
  },
  {
    value: 'PVD',
    label: t('h177'),
  },
]

export const statusReasonsRejectionObj = (t: any, el: string) => {
  if (!el) return '-'

  const list: { [key: string]: string } = {
    ICR: t('h173'),
    RPH: t('h174'),
    BQA: t('h175'),
    RQS: t('h176'),
    PVD: t('h177'),
  }
  return list[el]
}
